export default __webpack_public_path__ + "static/media/sl-entrance-dual.f1c4ff80.svg";